// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-step-editor-sidebar-advanced[data-v-8e87d58a]{padding:24px 16px}.social-step-editor-sidebar-advanced__group[data-v-8e87d58a]{margin-bottom:10px}.social-step-editor-sidebar-advanced__textarea[data-v-8e87d58a]{width:100%;word-break:break-word;border:none}.social-step-editor-sidebar-advanced__loader[data-v-8e87d58a]{margin:0 auto 10px}", ""]);
// Exports
module.exports = exports;
